/**
 * Компактная таблица объектов для Split View карта+таблица (Wave 1.4).
 */

import type { GeoObject } from "@/types/api-v2";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { cn } from "@/lib/utils";

interface MapObjectsSplitTableProps {
  objects: GeoObject[];
  selectedObjectId: number | null;
  multiSelectedObjectIds: number[];
  onRowClick: (object: GeoObject, additive: boolean) => void;
}

export default function MapObjectsSplitTable({
  objects,
  selectedObjectId,
  multiSelectedObjectIds,
  onRowClick,
}: MapObjectsSplitTableProps) {
  const multi = new Set(multiSelectedObjectIds);

  if (objects.length === 0) {
    return (
      <div className="flex h-full items-center justify-center p-4 text-sm text-muted-foreground">
        Нет объектов для отображения
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[64px]">ID</TableHead>
            <TableHead>Название</TableHead>
            <TableHead className="w-[100px]">Статус</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {objects.map((obj) => {
            const selected = selectedObjectId === obj.id;
            const inMulti = multi.has(obj.id);
            return (
              <TableRow
                key={obj.id}
                className={cn(
                  "cursor-pointer",
                  selected && "bg-accent",
                  inMulti && !selected && "bg-cyan-500/10",
                )}
                onClick={(e) => onRowClick(obj, e.shiftKey)}
              >
                <TableCell className="font-mono text-xs">{obj.id}</TableCell>
                <TableCell className="max-w-[280px] truncate text-sm">
                  {obj.name || "—"}
                </TableCell>
                <TableCell className="text-xs text-muted-foreground">{obj.status}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
